<div color="" class="px-4 nav-container">
    <div class="text-center logo-block" [routerLink]="['/payment-request']" style="cursor: pointer;">
        <img src="../../assets/logo.svg" alt="" width="220px">

        <div class="text-muted" *ngIf="currentJurisdiction">
            ({{ currentJurisdiction }})
        </div>
    </div>
    <div style="width:100%;">
        <div class="nav-items" *ngIf="loggedIn" style="float:right;">
            @if(hasAccessToPaymentRequest){
            <a mat-button [routerLink]="['/payment-request']" routerLinkActive="mat-accent" class="nav-item">
                <span class="d-none d-xxl-block">Payment Request</span>
                <span class="d-xxl-none">Payment<br />Request</span>
            </a>
            }

            @if(hasAccessToExpectFund)
            {
            <a mat-button [routerLink]="['/expect-fund']" routerLinkActive="mat-accent" class="nav-item">
                <span class="d-none d-xxl-block">Expected Funds</span>
                <span class="d-xxl-none">Expected<br />Funds</span>
            </a>
            }

            @if(hasAccessToTransferFunds)
            {
            <a mat-button [routerLink]="['/transfer-funds-request']" routerLinkActive="mat-accent" class="nav-item">
                <span class="d-none d-xxl-block">Transfer Request</span>
                <span class="d-xxl-none">Transfer<br />Request</span>
            </a>
            }

            @if(hasAccessToJournalRequest)
            {
            <a mat-button [routerLink]="['/journal-request']" routerLinkActive="mat-accent" class="nav-item">
                <span class="d-none d-xxl-block">Journal Request</span>
                <span class="d-xxl-none">Journal<br />Request</span>
            </a>
            }

            <a mat-button routerLinkActive="mat-accent" [routerLink]="['/user-requests']" class="nav-item">
                My Requests
            </a>
            @if(hasAccessToPaymentRequest){
            <a mat-button routerLinkActive="mat-accent" [routerLink]="['/draft-requests']" class="nav-item">
                Drafts
            </a>
            }
            <a mat-button routerLinkActive="mat-accent" [routerLink]="['/disbursement']" class="nav-item">
                Disbursement
            </a>
            <a mat-button *ngIf="hasAccessToApprovals" [routerLink]="['/approvals']" routerLinkActive="mat-accent" class="nav-item">
                Approvals
            </a>
            <a mat-button *ngIf="hasAccessToViewLogs" [routerLink]="['/audit']" routerLinkActive="mat-accent" class="nav-item">
                Audit
            </a>
            <a mat-button routerLinkActive="mat-accent" [routerLink]="['/completed-requests']" class="nav-item">
                Completed
            </a>
            <button mat-button [matMenuTriggerFor]="belowMenu">
                <div class="user-info">
                    <div class="initials-circle">{{userService.userDetails?.avatar}}</div>
                    <div class="user-text d-none d-lg-block">
                        <h4 class="username mb-0">
                            {{ userService.userDetails?.fullName }}
                        </h4>
                        <small class="user-role text-muted">
                            ({{ userRolePermissions?.actionstepRole }})
                        </small>
                    </div>
                </div>
            </button>
            <mat-menu #belowMenu="matMenu" yPosition="below">
                <button mat-menu-item *ngIf="isAccessToManageRoles" (click)="manageRoles()">
                    <mat-icon class="menu-icon">manage_accounts</mat-icon>
                    <span>Manage Roles</span>
                </button>

                <button mat-menu-item *ngIf="isAccessToManageRoles" (click)="openSupportedJurisdictions()">
                    <mat-icon class="menu-icon">public</mat-icon>
                    <span>Manage Jurisdictions</span>
                </button>

                <button mat-menu-item (click)="logOut()">
                    <mat-icon class="menu-icon">logout</mat-icon>
                    <span>Log Out</span>
                </button>
            </mat-menu>
        </div>
    </div>
</div>

